import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const entregaItems = [
  {
    title: 'Entrega',
    items: [
      'Aplicación web accesible desde cualquier dispositivo',
      'Interfaz simple e intuitiva',
      'Capacitación básica de uso',
    ],
  },
  {
    title: 'Tiempo estimado',
    items: ['2 a 4 semanas (dependiendo de ajustes y validaciones)'],
  },
  {
    title: 'Enfoque',
    items: [
      'Sistema práctico, fácil de usar y alineado con la operación actual del negocio',
      'Capacidad de crecer hacia una herramienta más completa de gestión financiera',
    ],
  },
];

const EntregaSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Entrega y despliegue
      </Typography>
      <Grid container spacing={3}>
        {entregaItems.map((section, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                height: '100%',
                borderTop: 3,
                borderColor: theme.palette.primary.main,
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                  {section.title}
                </Typography>
                {section.items.map((item, j) => (
                  <Typography key={j} variant="body2" color="textSecondary" paragraph sx={{ mb: 0.5 }}>
                    • {item}
                  </Typography>
                ))}
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EntregaSection;
